import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import {useModelContext} from "@app/contexts/model";
import {useStorageContext} from "@app/contexts/storage";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {MAIN_PAGE} from "@app/enums";
import {useStorageConfirmTranslateContext} from "@app/modules/ConfirmTranslate/contexts/storage";


interface IModalProps {

}


export const Alert: FunctionComponent<IModalProps> = observer<FunctionComponent<IModalProps>>(function () {

    const {translateStore} = useStorageTranslateContext()
    const {globalStorage} = useStorageContext();
    const {languageFileModel} = useModelContext()
    const {confirmTranslateStore} = useStorageConfirmTranslateContext()

    let openAlert = translateStore.openAlert

    return (
            <Dialog
                open={openAlert}
                onClose={() => translateStore.handleCloseAlertYes()}
                aria-describedby="alert-dialog-description"
                aria-labelledby="alert-dialog-title"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your data is unsaved. Do you want to save it?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        translateStore.confirmSave = false
                        translateStore.clear()
                        languageFileModel.dataLanguage.set(null)
                        confirmTranslateStore.clear()
                        if (globalStorage.SelfConfIconClicked) {
                            globalStorage.openModule = MAIN_PAGE.SELF_CONFIG
                        } else if (globalStorage.ConfirmSelectDiffTranslateIconClicked) {
                            globalStorage.openModule = MAIN_PAGE.CONFIRM_TRANSLATE
                        } else if (globalStorage.LogOutIconClicked) {
                            globalStorage.openModule = MAIN_PAGE.LOGOUT
                        }
                        else if (globalStorage.SelectDiffTranslateIconClicked) {
                            globalStorage.openModule = MAIN_PAGE.TRANSLATE
                        }
                        translateStore.handleCloseAlertNo()
                    }}
                            color="error" >
                        No
                    </Button>
                    <Button onClick={() => {
                        translateStore.confirmSave = true
                        globalStorage.openModule = MAIN_PAGE.TRANSLATE
                        translateStore.handleCloseAlertYes()
                    }}
                            color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
    );
});
